import { MarketingChannel } from "@redotech/redo-billing-common/marketing-channel";
import { SortDirection } from "@redotech/redo-model/tables/table";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const conversationLogEntrySchema_ = z.object({
  _id: z.string(),
  customerId: z.string(),
  customerName: z.string().optional(),
  lastMessageAt: z.date().optional(),
  lastInitialMessageAt: z.date().optional(),
  messageCount: z.number(),
  channel: createEnum(MarketingChannel),
});
export const conversationLogEntrySchema: z.ZodType<ConversationLogEntry> =
  conversationLogEntrySchema_;
export interface ConversationLogEntry
  extends z.infer<typeof conversationLogEntrySchema_> {}

const conversationLogsInputSchema_ = z.object({
  page: z.number().int().positive().default(1),
  pageSize: z.number().int().positive().max(100).default(20),
  sortKey: z
    .enum(["lastMessageAt", "lastInitialMessageAt"])
    .default("lastMessageAt"),
  sortDirection: createEnum(SortDirection).default(SortDirection.DESC),
  searchString: z.string().optional(),
});
export const conversationLogsInputSchema: z.ZodType<ConversationLogsInput> =
  conversationLogsInputSchema_;
export interface ConversationLogsInput
  extends z.infer<typeof conversationLogsInputSchema_> {}

const conversationLogsOutputSchema_ = z.object({
  conversations: z.array(conversationLogEntrySchema),
  totalCount: z.number(),
});
export const conversationLogsOutputSchema: z.ZodType<ConversationLogsOutput> =
  conversationLogsOutputSchema_;
export interface ConversationLogsOutput
  extends z.infer<typeof conversationLogsOutputSchema_> {}

export const getMarketingAgentConversationLogs = {
  name: "getMarketingAgentConversationLogs" as const,
  input: conversationLogsInputSchema,
  output: conversationLogsOutputSchema,
};
